export default "__VITE_ASSET__f8237c49__"